import api from './api';

export interface SeatAssignment {
  id?: number;
  teacher?: number;
  student: number;
  student_data?: any;
  seat_number: number;
  created_at?: string;
  updated_at?: string;
}

class SeatAssignmentService {
  async getAll(params?: any): Promise<SeatAssignment[]> {
    const response = await api.get('/seat-assignments/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getForTeacher(): Promise<SeatAssignment[]> {
    const response = await api.get('/seat-assignments/for_teacher/');
    return response.data;
  }

  async getById(id: number): Promise<SeatAssignment> {
    const response = await api.get(`/seat-assignments/${id}/`);
    return response.data;
  }

  async create(data: Partial<SeatAssignment>): Promise<SeatAssignment> {
    const response = await api.post('/seat-assignments/', data);
    return response.data;
  }

  async update(id: number, data: Partial<SeatAssignment>): Promise<SeatAssignment> {
    const response = await api.patch(`/seat-assignments/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/seat-assignments/${id}/`);
  }

  async getByStudent(studentId: number): Promise<SeatAssignment | null> {
    const response = await api.get('/seat-assignments/', { params: { student: studentId } });
    const assignments = response.data.results || response.data;
    return assignments.length > 0 ? assignments[0] : null;
  }
}

const seatAssignmentService = new SeatAssignmentService();
export default seatAssignmentService;
